import React from "react";

import { Icon } from "@proda-ai/ui-kit";

import Box from "@/ui/atoms/Box";

import type { ICellRendererParams } from "@/ui/molecules/Grid";

import type { TRowReviewWithOperatingStatements } from "../../typesGrids";
import { getPinnedRowBackgroundColor } from "../../utils";

const cellStylesWithEllipsis = {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "block",
};

type GridReviewRendererFirstColumnProps =
    ICellRendererParams<TRowReviewWithOperatingStatements>;

const GridReviewRendererFirstColumn: React.FC<
    GridReviewRendererFirstColumnProps
> = params => {
    const { data } = params;

    if (!data) return null;

    const pinnedRowBackgroundColor = getPinnedRowBackgroundColor(data);

    if (
        data.type === "TYPE" ||
        data.type === "SECTION" ||
        data.type === "TOTAL"
    ) {
        return (
            <Box
                sx={{
                    backgroundColor:
                        pinnedRowBackgroundColor ?? "var(--proda-white-l95)",
                    fontWeight: "bold",
                    textAlign: "right",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    ...cellStylesWithEllipsis,
                }}
            >
                {data.account}
            </Box>
        );
    }

    if (data.type === "HEADER") {
        return (
            <Box
                sx={{
                    backgroundColor: "var(--proda-white-130)",
                    fontWeight: "bold",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    ...cellStylesWithEllipsis,
                }}
            >
                {data.account}
            </Box>
        );
    }

    if (data.type === "SUBSECTION") {
        const chevronIcon =
            data.isExpanded === true ? "chevron-down" : "chevron-right";
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontWeight: "400",
                    paddingLeft: "12px",
                    paddingRight: "16px",
                }}
            >
                <Icon icon={chevronIcon} />
                <Box sx={cellStylesWithEllipsis}>{data.account}</Box>
            </Box>
        );
    }

    if (data.parentRowId == null) {
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: "400",
                    color: "var(--proda-black-10)",
                    paddingLeft: "12px",
                    paddingRight: "16px",
                }}
            >
                <Box sx={{ visibility: "hidden", display: "flex" }}>
                    <Icon icon="chevron-right" />
                </Box>
                <Box sx={cellStylesWithEllipsis}>{data.account}</Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                fontWeight: "400",
                color: "var(--proda-black-10)",
                paddingLeft: "36px",
                paddingRight: "16px",
                ...cellStylesWithEllipsis,
            }}
        >
            {data.account}
        </Box>
    );
};

export default GridReviewRendererFirstColumn;
